<ion-content class="bg-color ion-content create-api-catalog">
  <div class="api-catalog-content">
    <div class="breadcrumb-container">
      <ul class="breadcrumb-list">
        <li *ngFor="let list of apiCatalogList" class="breadcrumb-item">
          <a routerLink="{{ list.url }}">
            {{ list.label }}
          </a>
        </li>
      </ul>
    </div>

    <div class="api-form-layout">
      <div class="api-form-container">
        <form *ngIf="apiCatalogForm" [formGroup]="apiCatalogForm">
          <mat-card class="api-form-card">
            <mat-card-title class="api-form-title">
              <h4 class="api-form-header">Catalog</h4>
            </mat-card-title>
            <mat-card-content class="api-form-content">
              <div *ngIf="bubbleShow" class="category-tooltip">
                <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                <p>Select your Category. Based on Category selected the brand will be populated</p>
                <button mat-raised-button style="float: right;" (click)="closeBubble()">Got It</button>
              </div>
              <div class="api-form-sections">
                <div class="api-category-section">
                  <mat-form-field class="category-dropdown" appearance="outline">
                    <mat-label>Select Category</mat-label>
                    <mat-select formControlName="api_category" (selectionChange)="onChangeGetBrands($event)" required>
                      <mat-option *ngFor="let obj of categoryList" [value]="obj">{{obj.category}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="brand" class="brand-tooltip">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Select Brand</p>
                  <button mat-raised-button style="float: right;" (click)="closeBrand()">Select</button>
                </div>
                <div *ngIf="product" class="product-tooltip">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Select Product Name</p>
                  <button mat-raised-button style="float: right;" (click)="closeProduct()">Select</button>
                </div>

                <div class="api-brand-section">
                  <mat-form-field class="brand-dropdown" appearance="outline">
                    <mat-label>Select Brand</mat-label>
                    <mat-select formControlName="api_brand" (selectionChange)="onChangeGetProduct($event)" required>
                      <mat-option *ngFor="let obj of brandsList" [value]="obj">{{obj.brand_name}}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="product-dropdown" appearance="outline">
                    <mat-label>Select Product</mat-label>
                    <mat-select formControlName="api_product_name" (selectionChange)="onChangeGetType()" required>
                      <mat-option *ngFor="let obj of productList" [value]="obj">{{obj.product_name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="chooseType" class="type-tooltip">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Select Type</p>
                  <button mat-raised-button style="float: right;" (click)="closeType()">Select</button>
                </div>
                <div *ngIf="commerce" class="commerce-tooltip">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Enter Commerce</p>
                  <button mat-raised-button style="float: right;" (click)="closeCommerce()">Enter</button>
                </div>
                <div class="api-type-section">
                  <mat-form-field class="type-dropdown" appearance="outline">
                    <mat-label>Select Type</mat-label>
                    <mat-select formControlName="api_type" (selectionChange)="onChangeGetCommerce($event)" required>
                      <mat-option *ngFor="let obj of typeList" [value]="obj">{{obj.type}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="commerce-input" appearance="outline">
                    <mat-label>Commerce</mat-label>
                    <input type="text" formControlName="api_commerce" matInput placeholder="Commerce"
                      (change)="onChangeCommerce()" (keydown.enter)="$event.preventDefault()" required />
                  </mat-form-field>
                </div>
                <div *ngIf="priceDeals" class="price-tooltip">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Select price & deals</p>
                  <button mat-raised-button style="float: right;" (click)="closePrice()">Select</button>
                </div>

                <div class="api-price-section">
                  <mat-form-field class="price-dropdown" appearance="outline">
                    <mat-label>Select Price & Deals</mat-label>
                    <mat-select formControlName="api_price" (selectionChange)="onChangeGetPrice()" required>
                      <mat-option *ngFor="let obj of priceDealsList" [value]="obj">{{obj.price}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="businessObj" class="business-tooltip">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Enter Business Objects</p>
                  <button mat-raised-button style="float: right;" (click)="closeBusinessObj()">Enter</button>
                </div>
                <div class="api-business-section api-business-section-full">
                  <mat-form-field class="business-input" appearance="outline">
                    <mat-label>Business Objects</mat-label>
                    <input type="text" formControlName="api_business_object" matInput placeholder="Business object"
                      (change)="onChangeBusinessObj()" required />
                  </mat-form-field>
                </div>

                <div *ngIf="workflowStatus" class="workflow-tooltip">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Select Workflow Status</p>
                  <button mat-raised-button style="float: right;" (click)="closeWorkflowStatus()">Enter</button>
                </div>

                <div class="api-workflow-section api-workflow-section-full">
                  <mat-form-field class="workflow-dropdown" appearance="outline">
                    <mat-label>Workflow Status</mat-label>
                    <mat-select formControlName="workflow_status" (selectionChange)="onChangeWorkflow()" required>
                      <mat-option *ngFor="let obj of workflowList" [value]="obj">{{obj.status}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div *ngIf="description" class="description-tooltip">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Enter Description Here</p>
                  <button mat-raised-button style="float: right;" (click)="closeDescription()">Enter</button>
                </div>

                <div class="api-description-section api-description-section-full">
                  <mat-form-field class="description-input" appearance="outline">
                    <mat-label>Description</mat-label>
                    <textarea formControlName="api_description" style="height: 150px;" matInput
                      placeholder="Description" (change)="onChangeDescription()"
                      (keydown.enter)="$event.preventDefault()" required>
                  </textarea>
                  </mat-form-field>
                </div>

                <div *ngIf="updateApiImage" class="image-tooltip">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Upload the image here</p>
                  <button mat-raised-button style="float: right;" (click)="closeUpdateImage()">Select</button>
                </div>
                <div class="api-image-upload-section">
                  <div class="image-preview-container">
                    <div class="image-preview">
                      <img [src]="apiImagePath">
                      <mat-icon *ngIf="isEnableImageChanges" class="clear-image-icon"
                        (click)="clearImage()">highlight_off</mat-icon>
                    </div>
                    <div class="file-upload-container">
                      <input type="file" #apiImage (change)="uploadImage($event)" accept="image/x-png,image/jpeg"
                        (keydown.enter)="$event.preventDefault()" required />
                    </div>
                    <p class="file-upload-instructions">
                      Upload file format of jpg, jpeg and png only upto size of 100KB
                    </p>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- <mat-card class="m-card-main-content margin-top-10">

            <form [formGroup]="environmentForm">
              <div class="views-content-env" style="grid-template-columns: 100%;">
                <div class="views-content-env-data">
                  <div class="add-environment-button" style="text-align: right;">
                    <p>{{environmentForm.value.selected_environment}}</p>
                  </div>
                  <div class="add-environment-button">
                    <mat-icon class="icon" (click)="openEnvironment(true)">
                      add
                    </mat-icon>
                  </div>
                  <div class="exit-environment">
                    <mat-icon class="icon" (click)="exitEnvironment()">
                      move_down
                    </mat-icon>
                  </div>
                  <div class="env-settings">
                    <div class="env-settings-wrapper" (click)="toggleMenu()">
                      <mat-icon matTooltip="Environment Settings" matTooltipPosition="above">settings</mat-icon>
                      <mat-select class="env-settings-select"
                        formControlName="bridge_endpoint_selected_environments_name"
                        (selectionChange)="onEnvironmentChange($event)">
                        <mat-option value="No Environment">No Environment</mat-option>
                        <mat-option *ngFor="let tab of selectedEnvTabs" [value]="tab">
                          {{ tab }}
                        </mat-option>
                      </mat-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="m-body" *ngIf="showEnvironmentTab">
                <div class="env-container">
                  <div class="env-header">
                    <span class="env-header">Environment Setting</span>
                  </div>
                </div>
                <div class="environment-tab-group">
                  <div formArrayName="bridge_endpoint_environments_raw">
                    <div *ngFor="let environments of bridgeEnvironments().controls; let i = index">
                      <div [formGroupName]="i">
                        <ng-container *ngIf="i === currentDisplayedEnvIndex">
                          <div class="environment-tab">
                            <div class="environment-name">
                              <mat-form-field class="environment-name-field" appearance="outline">
                                <mat-label>Environment Name</mat-label>
                                <input matInput placeholder="Environment Name" type="text" formControlName="env_name">
                              </mat-form-field>
                            </div>
                            <div class="environment-icon">
                              <span class="environment-icon-flotter">
                                <mat-icon class="icon" (click)="confirmSaveEnv(environments.value.env_name,i)">
                                  save
                                </mat-icon>
                                <mat-icon class="icon" (click)="confirmDeleteEnv(environments.value.env_name,i)">
                                  delete
                                </mat-icon>
                              </span>
                            </div>
                          </div>
                          <div class="environment-variable-container">
                            <div class="environment-variable-tabs">
                              <div formArrayName="env_vars">
                                <ng-container *ngFor="let env of envData(i).controls; let envIndex = index">
                                  <div [formGroupName]="envIndex">
                                    <div class="data-options-wrapper-environment">
                                      <mat-form-field appearance="outline">
                                        <mat-label>Variable</mat-label>
                                        <input type="text" placeholder="Variable" matInput formControlName="variable">
                                      </mat-form-field>
                                      <mat-form-field class="mat-dropdown" appearance="outline">
                                        <mat-label>Type</mat-label>
                                        <mat-select placeholder="Type" formControlName="type"
                                          (selectionChange)="envChangeType($event,envIndex,i)">
                                          <mat-option *ngFor="let type of environmentType" [value]="type.value">{{
                                            type.viewValue }}</mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                      <mat-form-field appearance="outline">
                                        <mat-label>Value</mat-label>
                                        <input [type]="env.value.valueType" [id]="'environmentValue-' + envIndex"
                                          placeholder="Value" matInput formControlName="value">
                                        <mat-icon *ngIf="env.value.type === 'password'" matSuffix
                                          (click)="togglePassword(i, envIndex)">
                                          {{ env.value.valueType == 'password' ? 'visibility_off' : 'visibility'
                                          }}
                                        </mat-icon>
                                      </mat-form-field>
                                      <div class="btn-view">
                                        <mat-icon class="icon" (click)="addEnvironmentsTab(i)">
                                          add
                                        </mat-icon>
                                      </div>
                                      <div class="btn-view">
                                        <mat-icon class="icon" (click)="removeEnvironmentsTab(i, envIndex)">
                                          remove
                                        </mat-icon>
                                      </div>
                                    </div>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <div class="m-body" *ngIf="!showEnvironmentTab">
              <div class="views-content-data">
                <div class="data-options">
                  <div *ngIf="request" class="method">
                    <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                    <p>Select the request method</p>
                    <button mat-raised-button style="float: right;" (click)="closerequest()">Select</button>
                  </div>
                  <div *ngIf="requesturl" class="requesturl">
                    <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                    <p>Enter your request URL</p>
                    <button mat-raised-button style="float: right;" (click)="closerequesturl()">Got It</button>
                  </div>
                  <mat-form-field class="data-options-dropdown" appearance="outline">
                    <mat-select formControlName="api_endpoint_method" (selectionChange)="onSelectRequest()">
                      <mat-option *ngFor="let options of methodList" [value]="options" class="optionsList">
                        {{ options.method }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="data-url">
                  <mat-form-field class="data-url" appearance="outline" style="display: none;">
                    <input type="text" matInput placeholder="Request URL" formControlName="api_endpoint_url"
                      (change)="onChangeUrl()" (keydown.enter)="$event.preventDefault()">
                  </mat-form-field>
                    <div class="contentDiv" id="contentDiv" contenteditable="true" placeholder="Request URL" 
                  (keyup)="onKeyupEPUrl($event)">{{endpoint_url}}</div>
                </div>
                <div *ngIf="testurl" class="testurl">
                  <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                  <p>Click "Test" button to check the API</p>
                  <button mat-raised-button style="float: right;" (click)="closetesturl()">Got it</button>
                </div>

                <div class="data-btn" *ngIf="spinnerShow == false">
                  <button mat-raised-button type="button" class="btn-test" *ngIf="spinner == false" (click)="testApi()">Test</button>
                </div>
                
                <div class="data-btn" *ngIf="spinnerShow == true">
                  <button mat-raised-button type="button" class="btn-test btn-cancel" (click)="cancelSpinner()">Cancel</button>
                </div>

                <div class="loader-container" style="padding: 12px" *ngIf="spinner == true">
                  <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                </div>
              </div>
              <div *ngIf="authentication" class="authorization">
                <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                <p>Select Authorization type</p>
                <button mat-raised-button style="float: right;" (click)="closeauthentication()">Select</button>
              </div>
              <div *ngIf="header" class="headers">
                <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                <p>Fill the Headers Fields</p>
                <button mat-raised-button style="float: right;" (click)="closeheader()">Enter Field</button>
              </div>

              <mat-tab-group animationDuration="0ms" class="views-options-data-group" [(selectedIndex)]="indexSelection"
                (selectedTabChange)="postmanTabChange($event)">
                <mat-tab label="Params">
                  <div class="mat-section">
                    <div class="m-body">
                      <div class="data-options-wrapper">
                        <div class="data-options-grid" formArrayName="api_endpoint_params_raw"
                          *ngFor="let params of params?.controls;let i = index">
                          <ng-container [formGroupName]="i">
                            <mat-form-field appearance="outline" style="display: none;">
                              <input type="text" formControlName="paramKey" matInput placeholder="Key"
                                (keydown.enter)="$event.preventDefault()">
                            </mat-form-field>
                            <div class="contentDivInputContParams">
                              <div class="contentParams" id="contentDiv_params_key{{i}}" placeholder="Key" contenteditable="true" 
                            (keyup)="onKeyupEPParamsKey($event,i)">{{params_key[i]}}</div>
                            </div>
                            <mat-form-field appearance="outline" style="display: none;">
                              <input type="text" formControlName="paramValue" matInput placeholder="Value"
                                (keydown.enter)="$event.preventDefault()">
                            </mat-form-field>
                            <div class="contentDivInputContParams">
                              <div class="contentParams" id="contentDiv_params_value{{i}}" placeholder="Value" contenteditable="true" 
                            (keyup)="onKeyupEPParamsValue($event,i)">{{params_value[i]}}</div>
                            </div>
                            <mat-form-field appearance="outline">
                              <input type="text" formControlName="paramDescription" matInput placeholder="Description"
                                (keydown.enter)="$event.preventDefault()">
                            </mat-form-field>
                            <div class="btn-view">
                              <mat-icon class="icon" (click)="addParams(i)">add</mat-icon>
                            </div>
                            <div class="btn-view">
                              <mat-icon class="icon" (click)="removeParams(i)">remove</mat-icon>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                    </div>
                  </div>
                </mat-tab>
                <mat-tab label="Authorization">
                  <div class="mat-section">
                    <div class="m-body">
                      <div class="authentication-view">
                        <div class="view-options-drop">
                          <mat-form-field class="mat-dropdown" appearance="outline">
                            <mat-label>Select Type</mat-label>
                            <mat-select formControlName="api_endpoint_authentication_type"
                              (selectionChange)="onChangeAuthenticationtype($event)">
                              <mat-option *ngFor="let type of authenticationTypeOptions" [value]="type">
                                {{ type.type }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div class="view-body">
                          <ng-container *ngIf="selectType == 3">
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Token</mat-label>
                                <input type="text" matInput placeholder="Token" formControlName="authentication_token"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>
                            </div>
                          </ng-container>

                          <ng-container *ngIf="selectType == 4">
                            <div class="view-options">
                              <mat-form-field appearance="outline" style="display: none;">
                                <mat-label>Username</mat-label>
                                <input [type]="username ? 'password' : 'text'" matInput placeholder="Username"
                                  formControlName="authentication_username" (keydown.enter)="$event.preventDefault()">
                                <mat-icon matSuffix (click)="username = !username">{{username ? 'visibility_off' :
                                  'visibility'}}</mat-icon>
                              </mat-form-field>
                              <mat-label>Username *</mat-label>
                                <div class="contAiner">
                                  <div id="contentDevSourceAuthUser" placeholder="Username" contenteditable="true" 
                                  (keyup)="onKeyupEPAuthUser($event)"  (click)="onKeyupEPAuthUser($event)">{{source_authUser}}</div>
                                  <mat-icon class="buttOn" matSuffix (click)="toggleAuthPassword('contentDevSourceAuthUser','source_user')">{{username ?
                                    'visibility_off' : 'visibility'}}</mat-icon>
                                </div>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline" style="display: none;">
                                <mat-label>Password</mat-label>
                                <input [type]="password ? 'password' : 'text'" matInput placeholder="Password"
                                  formControlName="authentication_password" (change)="onChangeauthentication()"
                                  (keydown.enter)="$event.preventDefault()">
                                <mat-icon matSuffix (click)="password = !password">{{password ? 'visibility_off' :
                                  'visibility'}}</mat-icon>
                              </mat-form-field>
                              <mat-label>Password *</mat-label>
                                <div class="contAiner">
                                  <div id="contentDevSourceAuthPassword" type="password ? 'password' : 'text'" placeholder="Password" 
                                  contenteditable="true" (keyup)="onKeyupEPAuthPassword($event)" (click)="onKeyupEPAuthPassword($event)">{{source_authPassword}}</div>
                                    <mat-icon class="buttOn" matSuffix (click)="toggleAuthPassword('contentDevSourceAuthPassword','source_password')">{{password ?
                                    'visibility_off' : 'visibility'}}</mat-icon>
                                </div>
                            </div>
                          </ng-container>

                          <ng-container *ngIf="selectType == 6">
                            <div class="view-options-drop">
                              <mat-form-field appearance="outline">
                                <mat-label>Refresh Token Endpoint Method</mat-label>
                                <mat-select formControlName="oauth_refresh_token_endpoint_method">
                                  <mat-option *ngFor="let options of methodList" [value]="options">
                                    {{ options.method }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-label>Refresh Token Endpoint URL *</mat-label>
                              <mat-form-field appearance="outline" style="display: none;">
                                <mat-label>Refresh Token Endpoint URL</mat-label>
                                <input type="text" matInput placeholder="Refresh Token Endpoint URL"
                                  formControlName="oauth_refresh_token_endpoint_url"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>
                              <div class="contentDivInputContParams" id="contentDivAuth">
                                <div class="contentParams" id="contentDevAuth" contenteditable="true" placeholder="Refresh Token Endpoint URL" 
                               (keyup)="onKeyupEPAuth($event)" (click)="onKeyupEPAuth($event)">{{source_auth}}</div>
                              </div>
                            </div>
                            <div class="view-options-auth">
                              <mat-label>Refresh Token Endpoint Header</mat-label>
                              <ngx-codemirror class="codemirror-color" formControlName="oauth_refresh_token_endpoint_header"
                                #refreshTokenHeaderScriptEditor [options]="authorizationScriptEditorOptions">
                              </ngx-codemirror>
                            </div>
                            <div class="view-options-auth">
                              <mat-label>Refresh Token Endpoint Params</mat-label>
                              <ngx-codemirror class="codemirror-color" formControlName="oauth_refresh_token_endpoint_params"
                                #refreshTokenParamScriptEditor [options]="authorizationScriptEditorOptions">
                              </ngx-codemirror>
                            </div>
                            <div class="view-options-auth">
                              <mat-label>Refresh Token Endpoint Body</mat-label>
                              <ngx-codemirror class="codemirror-color" formControlName="oauth_refresh_token_endpoint_body"
                                #refreshTokenBodyScriptEditor [options]="authorizationScriptEditorOptions">
                              </ngx-codemirror>
                            </div>
                          </ng-container>

                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab label="Headers">
                  <div class="mat-section">
                    <div class="m-body">
                      <div class="data-options-wrapper">
                        <div class="data-options-grid" formArrayName="api_endpoint_headers"
                          *ngFor="let headers of headers?.controls;let i = index">
                          <ng-container [formGroupName]="i">
                            <mat-form-field appearance="outline" style="display: none;">
                              <input type="text" formControlName="headerKey" matInput placeholder="Key"
                                (keydown.enter)="$event.preventDefault()">
                            </mat-form-field>
                            <div class="contentDivInputContParams">
                              <div class="contentParams" id="contentDevHeaderKey{{i}}" placeholder="Key" contenteditable="true" 
                            (keyup)="onKeyupEPHeaderKey($event,i)">{{headers_key[i]}}</div>
                            </div>
                            <mat-form-field appearance="outline" style="display: none;">
                              <input type="text" placeholder="value" matInput formControlName="bridge_source_headerKey"
                                (keydown.enter)="$event.preventDefault()"
                                id="ib_update_source_endpoint_header_key{{i}}">
                            </mat-form-field>
                            <div class="autocomplete-container">
                              <div #contentDevHeaderValue id="contentDevHeaderValue{{i}}" placeholder="Value" contenteditable="true" 
                                class="contentEditable" (input)="onValueInput($event, i)" (focus)="onValueFocus(i)"
                                (blur)="hideValueAutocomplete(i)" (keyup)="onKeyupEPHeaderValue($event,i)">
                         
                              </div>
                              <div #autocompleteHeaderKey class="autocomplete-dropdown"
                                *ngIf="filteredHeaderValue[i]?.length">
                                <div class="autocomplete-item" *ngFor="let value of filteredHeaderValue[i]"
                                  (mousedown)="onValueOptionSelected(value.header_value, i)">
                                  {{ value.header_value}}
                                </div>
                              </div>
                            </div>

                            <mat-form-field appearance="outline">
                              <input type="text" formControlName="headerDescription" matInput placeholder="Description"
                                (change)="onChangeHeaders()" (keydown.enter)="$event.preventDefault()">
                            </mat-form-field>

                            <div class="btn-view">
                              <mat-icon class="icon" (click)="addheaders(i)">
                                add
                              </mat-icon>
                            </div>
                            <div class="btn-view">
                              <mat-icon class="icon" (click)="removeheader(i)">
                                remove
                              </mat-icon>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab label="Body">
                  <div class="mat-section">
                    <div style="width: 25%;">
                      <mat-form-field class="mat-dropdown" appearance="outline">
                        <mat-label>Select Type</mat-label>
                        <mat-select formControlName="api_endpoint_body_type">
                          <mat-option *ngFor="let type of bodyTypeOptions" [value]="type.type">
                            {{ type.type }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="m-body">
                      <ngx-codemirror formControlName="api_endpoint_body_raw" #bodyAPICatalogEditor
                        [options]="codeMirrorEditorOptions">
                      </ngx-codemirror>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab label="Pre-request Script">
                  <div class="mat-section">
                    <div class="m-body-script">
                      <ngx-codemirror class="codemirror-color" formControlName="pre_request_script" #preRequestScriptEditor
                        [options]="preRequestScriptEditorOptions">
                      </ngx-codemirror>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab label="Pagination" *ngIf="apiCatalogForm.value.api_type.type == 'Data Source'">
                  <div class="mat-section">
                    <div class="m-body">
                      <div class="pagination-view">
                        <div class="view-options">
                          <mat-form-field class="mat-dropdown" appearance="outline">
                            <mat-label>Select Type</mat-label>
                            <mat-select formControlName="bridge_source_pagination_type"
                              (selectionChange)="onChangeSourcePaginationtype($event)">
                              <mat-option *ngFor="let type of paginationTypeOptions" [value]="type">
                                {{ type.type }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div class="view-body">
                          <ng-container *ngIf="selectPaginationType == 2">
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>User Key</mat-label>
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_2"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Data Collection Key</mat-label>
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_2" (keydown.enter)="$event.preventDefault()"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Another Response Parameter</mat-label>
                                <input type="text" matInput placeholder="Offset Key"
                                  formControlName="another_response_parameter_2">
                              </mat-form-field>
                            </div>
                          </ng-container>

                          <ng-container *ngIf="selectPaginationType == 3">
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>User Key</mat-label>
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_3"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Key Name to Update</mat-label>
                                <input type="text" matInput placeholder="Key Name to Update"
                                  formControlName="key_name_to_update_3" (keydown.enter)="$event.preventDefault()"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Data Collection Key</mat-label>
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_3" (keydown.enter)="$event.preventDefault()"
                                  required>
                              </mat-form-field>
                            </div>
                          </ng-container>

                          <ng-container *ngIf="selectPaginationType == 4">
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>User Key</mat-label>
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_4"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Key Name to Update</mat-label>
                                <input type="text" matInput placeholder="Key Name to Update"
                                  formControlName="key_name_to_update_4" (keydown.enter)="$event.preventDefault()"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Data Collection Key</mat-label>
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_4" (keydown.enter)="$event.preventDefault()"
                                  required>
                              </mat-form-field>
                            </div>
                          </ng-container>

                          <ng-container *ngIf="selectPaginationType == 5">
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>User Key</mat-label>
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_5"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Key Name to Update</mat-label>
                                <input type="text" matInput placeholder="Key Name to Update"
                                  formControlName="key_name_to_update_5" (keydown.enter)="$event.preventDefault()"
                                  required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Data Collection Key</mat-label>
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_5" (keydown.enter)="$event.preventDefault()"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                          </ng-container>

                          <ng-container *ngIf="selectPaginationType == 6">
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>User Key</mat-label>
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_6"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>User Key URL</mat-label>
                                <input type="text" matInput placeholder="User Key URL" formControlName="user_key_url_6"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Data Collection Key</mat-label>
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_6" (keydown.enter)="$event.preventDefault()"
                                  required>
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectPaginationType == 7">
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>User Key</mat-label>
                                <input type="text" matInput placeholder="User Key" formControlName="user_key_7"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Data Collection Key</mat-label>
                                <input type="text" matInput placeholder="['items']"
                                  formControlName="response_parameters_7" (keydown.enter)="$event.preventDefault()"
                                  required>
                              </mat-form-field>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="selectPaginationType == 8">
                            <div class="view-options">
                              <p>Custom Pagination Script</p>
                              <div class="m-body-script" style="border:1px groove;border-radius: 5px;">
                                <ngx-codemirror formControlName="custom_pagination_script" #customPaginationScriptEditor
                                  [options]="codeMirrorEditorOptions">
                                </ngx-codemirror>
                              </div>
                            </div>
                          </ng-container>

                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab label="Numeric Params" *ngIf="apiCatalogForm.value.api_type.id == 1">
                  <div class="mat-section">
                    <div class="m-body">
                      <div class="pagination-view">
                        <div class="view-body">
                          <ng-container>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Minimun Number</mat-label>
                                <input type="number" matInput placeholder="Enter min number"
                                  formControlName="min_number" (keydown)="validateMinNum($event)">
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Maximum Number</mat-label>
                                <input type="number" matInput placeholder="Enter max number"
                                  formControlName="max_number" (keydown)="validateMaxNum($event)">
                              </mat-form-field>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab label="Time Params" *ngIf="apiCatalogForm.value.api_type.id == 1">
                  <div class="mat-section">
                    <div class="m-body">
                      <div class="pagination-view">
                        <div class="view-body">
                          <ng-container>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Today Format</mat-label>
                                <input type="text" matInput formControlName="today_str"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Yesterday Format</mat-label>
                                <input type="text" matInput formControlName="yesterday_str"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Rolling Time Format</mat-label>
                                <input type="text" matInput formControlName="rolling_time_format"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Rollling Frquency</mat-label>
                                <input type="number" matInput formControlName="rolling_frequency"
                                  (keydown)="validateMaxNum($event)" (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                            <div class="view-options">
                              <mat-form-field appearance="outline">
                                <mat-label>Time Offset Value</mat-label>
                                <input type="number" matInput formControlName="offset_value"
                                  (keydown.enter)="$event.preventDefault()" required>
                              </mat-form-field>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>

              <mat-divider></mat-divider>

              <div class="res-container">
                <div class="res-header">
                  <h3 style="margin:0">Response Params</h3>
                  <span class="res-header">
                    <mat-radio-group formControlName="response_type">
                      <mat-radio-button value="text">Text</mat-radio-button>
                      <mat-radio-button value="content">Content</mat-radio-button>
                      <mat-radio-button value="json">JSON</mat-radio-button>
                    </mat-radio-group>
                  </span>
                  <span class="res-status">
                    <mat-icon style="cursor: pointer;"
                      (click)="copyResponse(apiCatalogForm.controls.api_response.value)">
                      content_copy
                    </mat-icon>
                  </span>
                </div>
                <div class="res-header">
                  <span class="res-header">Response</span>
                  <span *ngIf="apiResponse">
                    <span class="res-status" *ngIf="apiResponse?.bizdata_dataset_status">Status:
                      <strong>{{apiResponse?.bizdata_dataset_status}}</strong></span>
                  </span>
                </div>
                <div class="res-body">
                  <div class="error-block" *ngIf="apiResponse?.error == 2; else se">
                    <h5>Could not send request</h5>
                    <span>Error: {{apiResponse.message}}</span>
                  </div>
                  <ng-template #se>
                    <json-editor formControlName="api_response" [options]="editorOptions">
                    </json-editor>
                  </ng-template>
                </div>
              </div>
              <div *ngIf="shownext" class="shownext">
                <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                <p>Click on Add to create API catalog</p>
                <button mat-raised-button style="float: right;" (click)="closeshownext()">Got it</button>
              </div>
              <div id="catalogid" class="btn-signup-grid">
                <button mat-raised-button class="btn" routerLink="/baseapp/api-catalog/view">Cancel</button>
                <button mat-raised-button type="submit" class="btn btn-signup"
                  (click)="onSubmitApiCatalog()">Add</button>
              </div>
            </div>
          </mat-card> -->

          <mat-card class="postman-api-catalog-create m-card-main-content">
            <app-postmanui *ngIf="apiCatalogFormType !== undefined" 
              [apiCatalogFormType]="apiCatalogFormType"></app-postmanui>
            <div class="api-catalog-action-section">
              <div *ngIf="addApiCatalog" class="addapi-tooltip">
                <span class="close-tooltip" (click)="closeBubbleCross()">&times;</span>
                <p>Click on Add to create API catalog</p>
                <button mat-raised-button style="float: right;" (click)="closeAddApiCatalog()">Got it</button>
              </div>
              <div id="catalogid" class="api-catalog-actions">
                <button mat-raised-button class="api-cancel-btn" routerLink="/baseapp/api-catalog/view">Cancel</button>
                <button mat-raised-button type="submit" class="api-submit-btn"
                  (click)="onSubmitApiCatalog()">Add</button>
              </div>
            </div>
            
          </mat-card>
        </form>
      </div>
      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>

    <app-footer *ngIf="!loader"></app-footer>
  </div>
</ion-content>